import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/data-grid/style/style.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
